class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartDiscountButton extends HTMLElement {
  constructor() {
    super();
    
    this.cart = this.closest("cart-drawer");
    this.addEventListener("click", this.onClick.bind(this));
  }

  connectedCallback() {
    this.addEventListener("click", this.onClick.bind(this));
  }
  
  reAtttachListeners() {
    const couponOpenButton = this.cart.querySelector(".more-offers");
    if (couponOpenButton) couponOpenButton.addEventListener("click", this.openOffers.bind(this));
    const couponCloseButton = this.cart.querySelector(".close-offers");
    if (couponCloseButton) couponCloseButton.addEventListener("click", this.closeOffers.bind(this));
  }

  openOffers() {
    const discountSection = this.cart.querySelector(".discount-section");
    if (discountSection) discountSection.style.display = "block";
  }
  
  closeOffers() {
    const discountSection = this.cart.querySelector(".discount-section");
    if (discountSection) discountSection.style.display = "none";
  }

  async onClick(event) {
    let message;
    const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
    const discount_code = cartItems.querySelector('.discount-box .discount-input').value;
    const discount_message = cartItems.querySelector('.button.discount-message');
    const button_text = discount_message.closest('.js-contents-discount').querySelector('cart-discount-button span')
    const button_loading = discount_message.closest('.js-contents-discount').querySelector('cart-discount-button .loading__spinner')
    if(discount_code == '') {
      this.message(discount_message,'Please enter coupen code')
      return;
    }
    button_text.classList.add('opacity-0');
    button_loading.classList.remove('hidden')
    
    const cart = await fetch('/cart.js')
    const cartJ = await cart.json()
    const total_discount = cartJ.total_discount

    await fetch(`/checkout?discount=${discount_code}`)
    const cart_new = await fetch('/cart.js')
    const cartJ_new = await cart_new.json()
    const total_discount_new = cartJ_new.total_discount
    if(total_discount != total_discount_new && total_discount > 0 && total_discount_new != 0 || total_discount < total_discount_new){
      message = 'Discount Applied'
      this.message(discount_message,message,'success')
      
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selectors = ['#CartDrawer-Form', '.cart-drawer__footer'];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
          this.reAtttachListeners();
        }
      })
      .catch((e) => {
        console.error(e);
      });
      
    }else{
      message = 'Discount Not Applied'
      this.message(discount_message,message)
    }
    button_text.classList.remove('opacity-0');
    button_loading.classList.add('hidden')
  }
  
  message(discount_message,message,success){
    discount_message.classList.remove('success')
    discount_message.querySelector('span').innerText = message;
    discount_message.classList.remove('hidden')
    if(success == 'success'){
      discount_message.classList.add('success')
      return true;
    }
    return false;
  }
}

customElements.define('cart-discount-button', CartDiscountButton)

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
    this.reAtttachListeners();
    this.updateCouponDaysRemaining();
    this.updateCouponButton();
    this.removeDiscountUpdate();
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  reAtttachListeners() {
    const couponOpenButton = this.querySelector(".more-offers");
    if (couponOpenButton) couponOpenButton.addEventListener("click", this.openOffers.bind(this));
    const couponCloseButton = this.querySelector(".close-offers");
    if (couponCloseButton) couponCloseButton.addEventListener("click", this.closeOffers.bind(this));
  }

  openOffers() {
    const discountSection = this.querySelector(".discount-section");
    if (discountSection) discountSection.style.display = "block";
  }
  
  closeOffers() {
    const discountSection = this.querySelector(".discount-section");
    if (discountSection) discountSection.style.display = "none";
  }

   updateCouponButton() {
     document.querySelectorAll('.apply-button').forEach(button => {
  button.addEventListener('click', async function () {
    const promoCard = this.closest('.promo-card');
    const promoCode = promoCard.querySelector('.promo-code').textContent.replace('PROMO CODE: ', '').trim();
    const discountMessage = promoCard.querySelector('.discount-message') || document.createElement('div');
    discountMessage.className = 'discount-message';
    promoCard.appendChild(discountMessage);

    if (!promoCode) {
      discountMessage.textContent = 'No promo code found.';
      discountMessage.classList.add('error');
      return;
    }

    try {
      const initialCart = await fetch('/cart.js').then(res => res.json());
      const initialDiscount = initialCart.total_discount;

      if (initialDiscount > 0) {
        discountMessage.textContent = 'Applying..';
        await fetch('/checkout?discount=');
      }

      await fetch(`/checkout?discount=${promoCode}`);

      const updatedCart = await fetch('/cart.js').then(res => res.json());
      const updatedDiscount = updatedCart.total_discount;

      if (updatedDiscount > 0) {
        discountMessage.textContent = 'Applied';
        discountMessage.classList.add('success');
        discountMessage.classList.remove('error');
      } else {
        discountMessage.textContent = 'Not applied. Please check your coupon code.';
        discountMessage.classList.add('error');
        discountMessage.classList.remove('success');
      }

      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then(response => response.text())
        .then(responseText => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['#CartDrawer-Form', '.cart-drawer__footer'];
          selectors.forEach(selector => {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
            var discountSections = document.getElementsByClassName("discount-section");
            for (var i = 0; i < discountSections.length; i++) {
              discountSections[i].style.display = "none";
            }
          });
        })
        .catch(e => console.error('Error refreshing cart drawer:', e));
    } catch (error) {
      console.error('Error applying discount:', error);
      discountMessage.textContent = 'An error occurred. Please try again.';
      discountMessage.classList.add('error');
    }
  });
       });
  }

  removeDiscountUpdate() {
  document.addEventListener('click', async function (event) {
    const removeLink = event.target.closest('.remove-discount-link');
    if (removeLink) {
    const button_text_dis = document.querySelector('.remove-cupon-button-wrapper .remove-discount-link')
      const button_loading_dis = document.querySelector('.remove-cupon-button-wrapper .loading__spinner')
      button_text_dis.classList.add('opacity-0');
      button_loading_dis.classList.remove('hidden')
      try {
        await fetch('/discount/clear');
        fetch(`${routes.cart_url}?section_id=cart-drawer`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const selectors = ['#CartDrawer-Form', '.cart-drawer__footer'];
            for (const selector of selectors) {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);
              }
            }
          })
          .catch((e) => {
            console.error('Error updating cart drawer:', e);
          });
      } catch (error) {
        console.error('Error clearing discount:', error);
      } finally {
        button_text_dis.classList.remove('opacity-0');
      button_loading_dis.classList.add('hidden')
      }
    }
  });
}

 

  
  updateCouponDaysRemaining() {
  const daysRemainingElements = document.querySelectorAll(".days-remaining");

  daysRemainingElements.forEach((element) => {
    const endDate = element.getAttribute("data-end-date");

    if (endDate) {
      const updateRemainingDays = () => {
        const today = new Date();
        const targetDate = new Date(endDate);
        const timeDifference = targetDate - today;
        const remainingDays = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

        if (remainingDays > 0) {
          element.textContent = `${remainingDays} days remaining`;
        } else {
          element.style.display = "none";
        }
      };

      updateRemainingDays();

      const now = new Date();
      const timeUntilMidnight =
        new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0) -
        now;

      setTimeout(() => {
        updateRemainingDays();
        setInterval(updateRemainingDays, 24 * 60 * 60 * 1000);
      }, timeUntilMidnight);
    } else {
      element.style.display = "none";
    }
  });
  }
  
  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    if(event.target.closest('.discount-input') == null){
      this.validateQuantity(event);
    }
    
  }

  

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents-foot',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

 